import {useCallback} from 'react';
import {useAiChatActions} from '@/ai-chat/providers/ai-chat.context';
import {saveAiChatImageToMyDesigns} from '@Components/ai-chat-window/lib/save-design.library';
import {LoadingStates} from '@Utils/loading.util';

interface UseSaveToMyDesignsReturn {
  onSaveToMyDesigns: () => Promise<void>;
}

export function useSaveToMyDesigns(chatId: string, hashedId: string): UseSaveToMyDesignsReturn {
  const actions = useAiChatActions();

  const onSaveToMyDesigns = useCallback(async (): Promise<void> => {
    actions.updateLoadingStatesForImageActions(chatId, hashedId, {saveToMyDesignsLoadingState: LoadingStates.LOADING});

    try {
      await saveAiChatImageToMyDesigns(hashedId);
    } catch (e: unknown) {
      console.error(e);
    } finally {
      actions.updateLoadingStatesForImageActions(chatId, hashedId, {saveToMyDesignsLoadingState: LoadingStates.LOADED});
    }
  }, [chatId, hashedId, actions]);

  return {onSaveToMyDesigns};
}
